export default __webpack_public_path__ + "static/media/exxonmobil.24adfa98.svg";